export function formatNumber(number: number): string {
  return new Intl.NumberFormat("da-DK").format(number);
}

export function formatPhoneNumber(number: number | string): string {
  const numStr = number.toString();
  if (numStr.length !== 8) return numStr;

  const parts = [];
  for (let i = 0; i < numStr.length; i += 2) {
    parts.push(numStr.substring(i, i + 2));
  }

  return parts.join(" ");
}

export function censorPhoneNumber(number: number | string): string {
  const numStr = number.toString();
  const firstHalf = numStr.slice(0, Math.floor(numStr.length / 2));
  return `${firstHalf}${"*".repeat(numStr.length - firstHalf.length)}`;
}
